import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-plus-outline',
  templateUrl: './icon-account-plus-outline.component.html',
  styleUrl: './icon-account-plus-outline.component.scss',
  standalone: false,
})
export class IconAccountPlusOutlineComponent {
  @Input() tooltip?: string;
}
